import { customBlockIcon } from '../icons';

const singlePostWithCustomHeading = {
  name: 'single-post-with-custom-heading',
  title: 'Single Post with Custom Title',
  icon: customBlockIcon,
  scope: ['block'],
  innerBlocks: [
    [
      'b3rg/div',
      {
        blockClassNames: [
          {
            value: `e-sgp__media`,
            label: 'e-sgp__media',
          },
        ],
        enableFocusableIcon: false,
        lockTemplate: 'false',
      },
      [['core/post-featured-image']],
    ],
    [
      'b3rg/div',
      {
        blockClassNames: [
          {
            value: `e-sgp__content`,
            label: 'e-sgp__content',
          },
        ],
        enableFocusableIcon: false,
        lockTemplate: 'false',
      },
      [
        ['core/heading'],
        ['core/post-date'],
        ['b3rg/meta-field', { selectedMetaField: 'learn_more_label' }],
      ],
    ],
  ],
};

export default singlePostWithCustomHeading;
